import {BaseDomainDataSource} from "../../infrastructure/models/base-domain-data-source";
import {AthleteGameLineupsResponseApiModel} from "./athlete-game-lineups-response.api-model";
import {CountryDomainModel} from "../common/country/models/country-domain-model";
import {CompetitionDomainModel} from "../common/competition/models/competition-domain-model";
import {CompetitorDomainModel} from "../common/competitor/models/competitor-domain-model";
import {PartialGameDomainModel} from "../partial-game/models/partial-game-domain-model";
import {LineupsMemberDomainModel} from "../yard/lineups/lineups-member/lineups-member-domain-model";
import {GameStatsCategoryDomainModel} from "../game-stats/models/category/game-stats.category.domain-model";
import {ChartEventsDomainModel} from "../full-game/models/chart-events/chart-events.domain-model";

export class AthleteGameLineupsDataSource extends BaseDomainDataSource {
  apiModel: AthleteGameLineupsResponseApiModel;
  countries: Array<CountryDomainModel>;
  competitions: Array<CompetitionDomainModel>;
  competitors: Array<CompetitorDomainModel>;
  game: PartialGameDomainModel;
  members: Array<LineupsMemberDomainModel>;
  statsCategories: Array<GameStatsCategoryDomainModel>;
  chartEvents: ChartEventsDomainModel;

  constructor(apiModel: AthleteGameLineupsResponseApiModel,
              countries: Array<CountryDomainModel>,
              competitions: Array<CompetitionDomainModel>,
              competitors: Array<CompetitorDomainModel>,
              games: Map<Number, PartialGameDomainModel>,
              members: Array<LineupsMemberDomainModel>,
              statsCategories: Array<GameStatsCategoryDomainModel>,
              chartEvents: ChartEventsDomainModel
  ) {
    super(apiModel);

    this.members = members;
    this.countries = countries;
    this.competitions = competitions;
    this.competitors = competitors;
    this.games = games;
    this.statsCategories = statsCategories;
    this.chartEvents = chartEvents;
  }
}